<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <section>

        <div class="head">
          <div>
          	<div :class="isSpecial?'head-img-ts':'head-img'">
          		<img :src="datas.product.img" />
          	</div>
          </div>
          <div class="head-title" v-if="!isSpecial" v-text="datas.product.name"></div>
          <div class="head-name">
          	<div class="head-icon"><img src="../../static/images/AntiFake03/icon03.png"></div>
          	<div v-if="datas.business.rootid === '100010171'">专业服务健康</div>
            <div v-else>{{ isSpecial?'品牌防伪追溯':datas.business.name }}</div>
          </div>
        </div>
        
        <div class="box">
          <div class="main">
          	<div class="main-title"><img class="main-icon" src="../../static/images/AntiFake03/icon04.png">查验结果</div>
            <div class="main-txt" v-if="isSpecial">{{ msg }}您所查询的防伪码已被查询{{datas.scan_count}}次，首次查询时间为：{{datas.scan_first_time}}，如不是您亲自查询，谨防假冒！</div>
          	<div class="main-txt" v-else>{{msg}}，首次查询时间 {{datas.scan_first_time}}，这次是第 {{datas.scan_count}} 次查询！</div>
          </div>
          <div class="nav" v-if="datas.menu && datas.menu_is_show == 1">
          	<ul>
          		<li v-for="(item,index) in datas.menu" v-bind:key="index" @click="ClickMenu(item)">{{item.name}}</li>
          	</ul>
          </div>
        </div>

      </section>

    </div>
  </div>
</template>

<script>
let self,map;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'AntiFake04',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data () {
    return {
      code:null,
      datas:null,
      msg:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      hintTxt:null,
      isShow:false,
      isSpecial: false
    }
  },
  created () {
    self = this;
    document.querySelector('body').setAttribute('style', 'background-color:#FFF');

    //判断是演示还是真实码标
    if(this.$route.query.type == "demo"){
      self.GetDemoDatas(this.$route.query.pid,this.$route.query.rid);  //获取演示模板信息
    }else{
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  updated () {
    new Swiper('.banner',{
      autoplay : {
        delay:5000
      },
      autoHeight: true, //高度随内容变化
    })
  },
  methods:{
    GetDemoDatas (pid,rid) {
      axios.get(self.GetServerUrl(1)+"template_product/"+pid+"/"+rid)
      .then(function (response){
        let datas = response.data.meta;
        let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息
        console.log(datas)
        if(datas.scan_count){
          datas.scan_count = datas.scan_count;
        }else{
          datas.scan_count = 1;
        }
        datas.scan_first_time = "2017-10-31 12:12";
        datas.scan_first_address = "广东省深圳市";
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }else{
          if(defaultDatas.ref){
            datas.ref = JSON.parse(defaultDatas.ref);
          }
        }
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        if(datas.batch){
          datas.batch = JSON.parse(datas.batch);
          datas.batch.qc = JSON.parse(datas.batch.qc);
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;

        //产品自定义属性
        if(datas.product.attribute){
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }

        //企业自定义属性
        if(datas.business.customize_data){
          datas.business.customize_data = JSON.parse(datas.business.customize_data);
        }

        //默认信息
        if(!datas.process){
          datas.process = defaultDatas.process;
        }
        if(!datas.process_demo){
          datas.process_demo = defaultDatas.process_demo;
        }
        if(!datas.dealer){
          datas.dealer = defaultDatas.dealer;
        }
        self.datas = datas;

        // document.title = self.datas.business.name;  //设置页面标题
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    GetDatas () {
      axios.get(self.GetServerUrl(1)+"query/"+self.code)
      .then(function (response){

        let datas = response.data.meta.product_template;
        datas.scan_count = response.data.meta.scan_count;  //扫码次数
        datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
        datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
        
        self.msg = "你所查询的是 "+datas.business.name+" 产品"
        if(datas.first_antifake_msg){
          self.msg = datas.first_antifake_msg;
        }

        //针对某企业设置
        if(datas.scan_count > 1 && datas.business.rootid == "100010028"){
          datas.scan_count--
        }

        //产品自定义属性
        if(datas.product.attribute){
          datas.product.attribute = JSON.parse(datas.product.attribute);
        }

        //企业自定义属性
        if(datas.business.customize_data){
          datas.business.customize_data = JSON.parse(datas.business.customize_data);

          if(datas.business.customize_data){
            for(let i in datas.business.customize_data){
              if(datas.business.customize_data[i].key == "经纬度"){
                self.location = datas.business.customize_data[i].value;
              }
            }
          }

        }
        //焦点图
        if(datas.focus){
          datas.focus = JSON.parse(datas.focus);
        }
        //自定义栏目
        if(datas.ref){
          datas.ref = JSON.parse(datas.ref);
        }
        //自定义菜单
        if(datas.menu){
          datas.menu = JSON.parse(datas.menu);
        }
        //批次信息
        if(datas.batch){
          if(datas.batch.qc){
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
        }
        if(datas.music && datas.music_is_show == 1){
          try {
            datas.music = JSON.parse(datas.music);
          } catch (error) {
            console.error(error)
          }
        }
        if(datas.video){
          datas.video = JSON.parse(datas.video);
        }
        datas.activity_is_show = 1;
        self.datas = datas;

        //特殊样式
        if(['100010319'].includes(datas.business.rootid)){
          self.isSpecial = true;
        }

        if(self.datas.business.rootid === '100010171'){
          document.title = '瑞年';
        }else{
          // document.title = self.datas.business.name;  //设置页面标题
        }
      }).catch(function (error){
        console.log(error)
        self.Loading.type = 3;
        self.Loading.txt = self.ErrorHint(error);
      })
    },
    ClickMenu (data) {
      if(data.type != 2){
        window.location.href = data.url;
      }else{
        this.$router.push({path: "/qr?qr="+data.qr});
      }
    }
  }
}
</script>

<style scoped>
.head{
	overflow: hidden;
	background-color: #2c6844;
}
.head-img{
	width: 50px;
	height: 50px;
	border-radius: 50px;
	overflow: hidden;
	margin: 20px auto;
  background-color: #6db72c;
}
.head-img-ts{
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.head-img-ts img{
  width: 130px;
	margin-top: 20px;
}
.head-img img{
	width: 100%;
	height: 100%;
  object-fit: cover;
}
.head-title{
	text-align: center;
	color: #FFF;
}
.head-name{
	color:#aebda8;
	font-size: 14px;
	display: table;
	margin:15px auto;
	position: relative;
	padding-left:20px;
}
.head-icon{
	left:0;top:3px;
	height: 15px;
	width: 15px;
	border-radius: 30px;
	background-color: #6db72c;
	position: absolute;
}
.head-icon img{
	width: 8px;
	display: block;
	margin:5px auto;
}
.main{
	padding:20px 15px;
}
.main-title{
	position: relative;
	padding-left: 25px;
}
.main-txt{
	color:#1c711e;
	margin-top: 12px;
	font-weight: bold;
	line-height: 25px;
}
.main-icon{
	position: absolute;
	left:0;top:0;
	width: 20px;
}
.nav ul{
	overflow: hidden;
}
.nav ul li{
	padding:16px;
	border-top:1px solid #e9e9e9;
}
.nav ul li:last-child{
	border-bottom: 1px solid #e9e9e9;
}
</style>



// WEBPACK FOOTER //
// src/view/AntiFake04.vue